const styles = (theme) => ({
	subtitulo: {
		color: theme.palette.text.secondary,
		marginBottom: "12px",
	},
	loadingContainer: {
		display: "flex",
		justifyContent: "center",
		padding: "24px",
	},
	erro: {
		color: theme.palette.chip.colorText.critical,
	},
	listasContainer: {
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	blocoLista: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	tituloLista: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},
	textoExplicativo: {
		color: theme.palette.text.secondary,
	},
	// Destaque de alerta - customizacao local que bloqueia a atualizacao automatica, sempre no par chip.background/colorText.high
	blocoAlerta: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		padding: "12px",
		borderRadius: "8px",
		backgroundColor: theme.palette.chip.background.high,
	},
	textoAlerta: {
		color: theme.palette.chip.colorText.high,
		fontWeight: 600,
	},
	lista: {
		margin: 0,
		paddingLeft: "20px",
		maxHeight: "160px",
		overflowY: "auto",
	},
	itemLista: {
		fontSize: "0.85rem",
		color: theme.palette.text.primary,
		wordBreak: "break-all",
	},
	// Mesmo item de lista, mas dentro do bloco de alerta - usa o par completo chip.colorText.high
	// (fundo do bloco ja e chip.background.high) pra nao anular a garantia de contraste
	itemListaAlerta: {
		fontSize: "0.85rem",
		color: theme.palette.chip.colorText.high,
		wordBreak: "break-all",
	},
	semItens: {
		color: theme.palette.text.secondary,
	},
});

export default styles;
